import React, { Component } from 'react';

import jQuery from 'jquery';
import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';

import {    addPlayArea, getLocationList, emailExist_check, playareaEdit, playareaReject, commonAPI } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';
import { MOBILE_REGEX, URL_REGEX } from '../../constant.js';
import { Modal, ModalBody, Row, Col, ModalFooter } from 'reactstrap';

import Geocode from "react-geocode";
import { Multiselect } from 'multiselect-react-dropdown';
import SimpleReactValidator from 'simple-react-validator';

Geocode.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
Geocode.setLanguage("en");
Geocode.setRegion("es");
Geocode.enableDebug();

class verticalKidsPlayAreaEdit extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      pageid: '',
      registration_no: '',
      area: '',
      facilitiesList: [],
      playarea_name: '',
      age_group: '',
      email_id: '',
      phone_number: '',
      landline_number: '',
      website: '',
      about_playarea: '',
      state: '',
      location: 'Bengaluru',
      country: '',
      pin_code: '',
      address: '',
      price_per_hour: '',
      google_location: '',
      no_of_support_staff: '',
      establishment_year: '',
      facilities: [],
      timing: '',
      modeofpayment: '',
      categoryTypeList: [],
      timingList: [],
      mopList: [],
      photos: '',
      latitude: '',
      longitude: '',
      other_rating: '',
      attachment_file: [],
      attachment_file_length: 0,
      attachment_fileName: [],
      from_time: '',
      from_time_cate: 'AM',
      to_time: '',
      to_time_cate: 'AM',
      edit_image: '',
      delete_array: [],
      location_list: [],
      categorySubTypeList: [],
      cat_type: false,
      sub_type: '',
      tempBanner: '',
      preview: false,
      edited_data: [],
      keywordsArr: [],
      edited: false
    };
    this.validator = new SimpleReactValidator({
      validators: {
        checkExist: {  // name the rule
          message: 'The :attribute field is required.',
          rule: (val, params, validator) => {
            if (val == '' && this.state.edit_image == '') {
              return false;
            }
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        },
        emailExist_check: {  // name the rule
          message: 'The :attribute Already Exist.',
          rule: (val, params, validator) => {
            return this.state.isEmailValid;
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        },
        checkMobile: MOBILE_REGEX,
        checkUrl: URL_REGEX
      }
    });
    this.id = this.props.match.params.id;
    this.loadFile = this.loadFile.bind(this)

    if (this.id !== undefined) {
      this.getPlayAreaInfo = this.getPlayAreaInfo.bind(this);
      this.getPlayAreaInfo();
    }
    this.getKeywords();
    this.Cat_type(); this.getfacilities(); this.gettiming(); this.getpayment_type();
    this.Sub_Cat_type();
  }
  componentDidMount() {
    let user_data = localStorage.getItem("user_data");
    let auth_data = JSON.parse(user_data);
    let vendor_id = auth_data.login_id;
    this.setState({
      vendor_id: vendor_id,
      role: auth_data.role,
    });

    this.LocationDataList();

  }
  componentDidUpdate() {
    window.jQuery('.selectpicker').selectpicker('refresh');
  }


  getKeywords = () => {
    commonAPI(JSON.stringify({ url: 'get_site_keywords', vertical:'kidsplayarea'})).then((res) => {
      if (res.status === 1) {
        this.setState({
          keywordsArr: res.results
        })
      }
    })
  }
  async getPlayAreaInfo() {
    let response = await playareaEdit(JSON.stringify({ id: this.id }));
    console.log(response);
    if (response.status === 1) {
      const data = response.data, edited_data = response.original;
      this.setState({
        registration_no: data.registration_no,
        pageid: data.id,
        area: data.area,
        playarea_name: data.organisation_name,
        age_group: data.sub_categories.split(','),
        email_id: data.email_id,
        phone_number: data.phone_number,
        landline_number: data.land_line,
        website: data.website,
        about_playarea: data.about,
        state: data.state,
        location: data.location,
        country: data.country,
        pin_code: data.pincode,
        address: data.address,
        ownerName: data.owner_name,
        google_location: data.google_location,
        no_of_support_staff: data.no_teacher,
        establishment_year: data.est_year,
        facilities: data.facilites.split(','),
        entry_fee: data.entry_fee,
        edit_image: data.images ? data.url + data.images : '',
        photos: data.photos,
        images: data.images,
        edit_photos: data.photos,
        keywords: data.keywords ? data.keywords.split(';') : [],
        from_time: data.from_time,
        to_time: data.to_time,
        from_time_cate: data.from_time_cate,
        to_time_cate: data.to_time_cate,
        attachment_file: data.photo_arr,
        other_rating: data.other_rating,
        latitude: data.latitude,
        longitude: data.longitude,
        sub_type: data.sub_type.split(','),
        edited: data.edited,
        edited_data: edited_data
      });
      this.Geocode_location(data.google_location);
    } else {
      window.location.href = document.referrer;
    }
  }
  async Cat_type() {
    let response = await FetchCall.getSubCategory('3');
    console.log('categoryTypeList', response);
    if (response) {
      this.setState({ categoryTypeList: response.results });
    }
  }
  async getfacilities() {
    let response = await FetchCall.getSchoolListDatas('facilities');
    console.log(response);
    if (response) {
      this.setState({ facilitiesList: response.results });
    }
  }
  async gettiming() {
    let response = await FetchCall.getSchoolListDatas('timing');
    console.log(response);
    if (response) {
      this.setState({ timingList: response.results });
    }
  }
  async getpayment_type() {
    let response = await FetchCall.getSchoolListDatas('payment_type');
    console.log(response);
    if (response) {
      this.setState({ mopList: response.results });
    }
  }

  async Sub_Cat_type() {
    let response = await FetchCall.getSchoolListDatas('play_age');
    if (response.status == 1) {
      this.setState({ categorySubTypeList: response.results, cat_type: true });
    } else {
      this.setState({ cat_type: false });
    }
  }
  showValidationErr(elm, msg) {
    this.setState((prevState) => ({
      errors: [...prevState.errors, { elm, msg }],
    }));
  }
  clearValidationErr(elm) {
    this.setState((prevState) => {
      let newArr = [];
      for (let err of this.state.errors) {
        if (elm !== err.elm) {
          newArr.push(err);
        }
      }
      return { errors: newArr };
    });
  }

  LocationDataList = async () => {
    try {
      const res = await getLocationList();
      if (res.status == 1) {
        console.log('location_list', res.results)

        this.setState({
          location_list: res.results,
          error: false
        });
      }

    } catch (error) {
      this.setState({ error: true });
    }
  };

  removeImage = e => {
    var delete_array = this.state.delete_array;
    delete_array.push(e)
    const updated = this.state.attachment_file.filter(item => item.name !== e)
    this.setState({
      attachment_file: updated,
      delete_array: delete_array,
    })
  }

  remove_img() {
    jQuery('#edit_image').remove();
  }
  loadFile(e) {
    var files = e.target.files
    this.setState({ attachment_file_length: files.length })
    if (files.length > 0) {
      jQuery('.upload-space').addClass('hide')
      jQuery('.upload-thumb').removeClass('hide')
      var fileArra = this.state.attachment_file

      //console.log('fileArra',fileArra)
      //var fileThumbArra = this.state.imgThumb;
      for (var i = 0; i < files.length; i++) {
        fileArra.push(e.target.files[i])
        this.setState({
          selectedFile: URL.createObjectURL(e.target.files[i]),
          attachment_file: fileArra
        })
      }
      this.clearValidationErr('attachment_file');
    }
  }

  handleChange = (e) => {
    const propName = e.target.name;
    this.setState({ [e.target.name]: e.target.value });
    this.clearValidationErr(propName);
    // if (propName == 'google_location') {
    //   this.Geocode_location();
    //   }
    if (e.target.name == 'google_location')
      this.Geocode_location();
    // if (propName == 'email_id') {
    //   this.validateMail(e.target.value, 3, this.state.vendor_id, this.state.pageid);
    // }
  };

  onSelect = (selectedList) => {
    let keywords = [];
    selectedList.map((item, i) => {
      keywords.push(item)
    });
    this.setState({
      keywords: keywords,
    });
  }
  onRemove = (selectedList, removedItem) => {
    let keywords = [];
    selectedList.map((item, i) => {
      keywords.push(item)
    });
    this.setState({
      keywords: keywords,
    });
  }
  validateMail = (value, catgry, vendr_id, pageid) => {
    let name = 'email_id';
    let type_name = 'isEmailValid';
    let req = JSON.stringify({
      [name]: value,
      category: catgry,
      vendor_id: vendr_id,
      pageid: pageid
    });
    let res = emailExist_check(req).then(res => {
      console.log('valuee', res);
      if (res.status === 1) {
        this.setState({
          [type_name]: false
        });
      } else {
        // return res.status;
        this.setState({
          [type_name]: true
        });
      }
    });
  }
  handleNumberChange = (e) => {
    let regexp = /^[0-9\b]+$/
    let Mnumber = e.target.value;

    if (e.target.value === '' || regexp.test(e.target.value)) {
      this.setState({ [e.target.name]: Mnumber })
    }
    this.Geocode_location();
  }


  handleFile = (e) => {
    // this.Geocode_location();
    const propName = e.target.name;
    const files = e.target.files[0];
    this.setState({ [propName]: files });
    const reader = new FileReader();
    let img = '';
    let THIS = this;
    reader.addEventListener("load", function () {
      // convert image file to base64 string
      img = reader.result;
      THIS.setState({
        tempBanner: reader.result
      });
    }, false);

    if (files) {
      reader.readAsDataURL(files);
    } else {
      THIS.setState({
        tempBanner: ''
      });
    }
  };

  handleFileMultiple = (e) => {
    this.setState({ [e.target.name]: e.target.files });
  };
  handleSelect = (e) => {
    const propName = e.target.name;
    const value = [...e.target.selectedOptions].map((item) => item.value);
    this.Sub_Cat_type(value);
    this.setState({ [propName]: value });
    this.clearValidationErr(propName);
  };

  handleSelectCat1 = (e) => {
    const propName = e.target.name;
    const value = [...e.target.selectedOptions].map((item) => item.value);
    this.setState({ [propName]: value });
  }

  Geocode_location(location = '') {
    Geocode.fromAddress(location ? location : this.state.google_location).then(
      response => {
        const { lat, lng } = response.results[0].geometry.location;
        if (lat && lng)
          this.get_location(lat, lng);
      },
      error => {
        console.error(error);
      }
    );

  }


  get_location(lat, lng) {
    this.setState({
      latitude: lat,
      longitude: lng
    });
  }
  handlePreview = (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({
        preview: true
      })
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  }

  render() {
    const { edited_data, edited } = this.state;
    this.validator.purgeFields();

        return (  
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Kids Play Area Info Management</h4>
                                   
                   <div className="row">

                   <div className="content-sec col-md-12 col-xs-12 pad-no mar-t-no">
                  <div className="tab-content">
                    <div id="company-info" className="tab-pane active">
                      <form
                        method="post"
                        onSubmit={this.handlePreview}
                        autoComplete="off"
                        className="custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no"
                      >
                        <div className="box-shadow-custom">
                          <div className="row">
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.registration_no != this.state.registration_no) && 'edited-field'}>
                                Registration No {this.state.user_type == 1 && <span className="astrick">*</span>}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="registration_no"
                                value={this.state.registration_no}
                                onChange={this.handleChange}
                              />
                              {
                                this.state.user_type == 1 &&
                                (
                                  this.validator.message('Registration No', this.state.registration_no, 'required', { className: 'text-danger' })
                                )
                              }
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.owner_name != this.state.ownerName) && 'edited-field'}>
                                Owner Name {this.state.user_type == 1 && <span className="astrick">*</span>}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="ownerName"
                                value={this.state.ownerName}
                                onChange={this.handleChange}
                              />
                              {
                                this.state.user_type == 1 &&
                                (
                                  this.validator.message('Owner Name', this.state.ownerName, 'required', { className: 'text-danger' })
                                )
                              }
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.organisation_name != this.state.playarea_name) && 'edited-field'} >
                                Organization Name <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="playarea_name"
                                value={this.state.playarea_name}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {
                                this.state.user_type == 1 &&
                                (
                                  this.validator.message('Organization Name', this.state.playarea_name, 'required', { className: 'text-danger' })
                                )
                              }
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.sub_categories != this.state.age_group) && 'edited-field'} >
                                Play Options<span className="astrick">*</span>
                              </label>
                              <div className="custom-select-drop dropdown">
                                <select
                                  multiple
                                  className="form-control selectpicker"
                                  onChange={this.handleSelect}
                                  name="age_group"
                                  value={this.state.age_group}
                                >
                                  {this.state.categoryTypeList.length > 0 &&
                                    this.state.categoryTypeList.map((item, i) => {
                                      return (
                                        <option value={item.category_id} >
                                          {item.category_name}
                                        </option>
                                      )
                                    })}
                                </select>
                                {this.validator.message('Play Options', this.state.age_group, 'required', { className: 'text-danger' })}
                              </div>
                            </div>

                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.sub_type != this.state.sub_type) && 'edited-field'}> Catering to Age group<span className="astrick">*</span></label>
                              <div className='custom-select-drop dropdown'>
                                <select
                                  multiple
                                  onChange={this.handleSelectCat1}
                                  name="sub_type"
                                  value={this.state.sub_type}
                                  className='form-control selectpicker' >
                                  {/* <option value="">select</option> */}
                                  {this.state.categorySubTypeList.length > 0 &&
                                    this.state.categorySubTypeList.map((item, i) => {
                                      return (
                                        <option value={item.id} >
                                          {item.name}
                                        </option>
                                      )
                                    })}
                                </select>
                                {this.validator.message('Catering to Age group', this.state.sub_type, 'required', { className: 'text-danger' })}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="box-shadow-custom">
                          <div className="row">
                            <div className="col-md-12 col-xs-12">
                              <span className="form-legend">
                                Address Information
                              </span>
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.email_id != this.state.email_id) && 'edited-field'}>
                                Email Id<span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="email_id"
                                value={this.state.email_id}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Email Id', this.state.email_id, 'emailExist_check', { className: 'text-danger' })}
                              {/* {this.validator.message('Email Id', this.state.email_id, 'required|email', { className: 'text-danger' })} */}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.phone_number != this.state.phone_number) && 'edited-field'}>
                                Phone Number<span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="phone_number"
                                value={this.state.phone_number}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Phone Number', this.state.phone_number, '', { className: 'text-danger' })}
                              {/* {this.validator.message('Phone Number', this.state.phone_number, 'required|checkMobile|min:10|max:60', { className: 'text-danger' })} */}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.land_line != this.state.landline_number) && 'edited-field'}>
                                Landline Number<span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="landline_number"
                                value={this.state.landline_number}
                                onChange={this.handleChange}
                                className="form-control" maxLength="12"
                              />
                              {this.validator.message('Landline Number', this.state.landline_number, '', { className: 'text-danger' })}
                              {/* {this.validator.message('Landline Number', this.state.landline_number, 'required|numeric', { className: 'text-danger' })} */}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.website != this.state.website) && 'edited-field'}>
                                Website<span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="website"
                                value={this.state.website}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Website', this.state.website, '', { className: 'text-danger' })}
                              {/* {this.validator.message('Website', this.state.website, 'required|checkUrl', { className: 'text-danger' })} */}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.state != this.state.state) && 'edited-field'}>
                                State<span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="state"
                                value={this.state.state}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('State', this.state.state, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.location != this.state.location) && 'edited-field'}>
                                Location<span className="astrick">*</span>
                              </label>
                              <select
                                name="location"
                                id="location"
                                onChange={this.handleSelect}
                                value={this.state.location}
                                className="form-control selectpicker"
                              // multiple
                              >
                                {this.state.location_list.length > 0 &&
                                  this.state.location_list.map((item, i) => {
                                    return (
                                      <option value={item.location} >
                                        {item.location}
                                      </option>
                                    )
                                  })}
                              </select>
                              {this.validator.message('Location', this.state.location, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.pincode != this.state.pin_code) && 'edited-field'}>
                                Pincode<span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="pin_code"
                                value={this.state.pin_code}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Pincode', this.state.pin_code, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.address != this.state.address) && 'edited-field'}>
                                Address<span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="address"
                                value={this.state.address}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Address', this.state.address, 'required', { className: 'text-danger' })}
                            </div>

                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.google_location != this.state.google_location) && 'edited-field'}>
                                Google Location Address
                                <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="google_location"
                                value={this.state.google_location}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Google Location', this.state.google_location, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.latitude != this.state.latitude) && 'edited-field'}>
                                Latitude
                                <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="latitude"
                                value={this.state.latitude}
                                onChange={this.handleChange}

                                className="form-control"
                              />
                              {this.validator.message('Latitude', this.state.latitude, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.longitude != this.state.longitude) && 'edited-field'}>
                                Longitude
                                <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="longitude"
                                value={this.state.longitude}
                                onChange={this.handleChange}

                                className="form-control"
                              />
                              {this.validator.message('Longitude', this.state.longitude, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.other_rating != this.state.other_rating) && 'edited-field'}>
                                Google Rating
                                <span className="astrick">*</span>
                              </label>
                              <input
                                type="number"
                                step='0.01'
                                name="other_rating"
                                value={this.state.other_rating}
                                onChange={this.handleChange}
                                max='5'
                                className="form-control"
                              />
                              {this.validator.message('Google Rating', this.state.other_rating, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.about != this.state.about_playarea) && 'edited-field'}>
                                About the School
                                <span className="astrick">*</span>
                              </label>
                              <textarea
                                type="text"
                                name="about_playarea"
                                value={this.state.about_playarea}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('About', this.state.about_playarea, 'required', { className: 'text-danger' })}
                            </div>
                          </div>
                        </div>
                        <div className="box-shadow-custom">
                          <div className="row">
                            <div className="col-md-12 col-xs-12">
                              <span className="form-legend">Key Information</span>
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.facilities != this.state.facilities) && 'edited-field'}>
                                Facilities<span className="astrick">*</span></label>
                              <div className="custom-select-drop dropdown">
                                <select
                                  multiple
                                  name="facilities"
                                  id="facilities"
                                  onChange={this.handleSelect}
                                  className="form-control selectpicker"
                                  value={this.state.facilities}
                                  title='Select'
                                >
                                  {this.state.facilitiesList.length > 0 &&
                                    this.state.facilitiesList.map((item, i) => {
                                      return (
                                        <option value={item.id} >
                                          {item.facility}
                                        </option>
                                      )
                                    })}
                                </select>
                                {this.validator.message('Facilities', this.state.facilities, 'required', { className: 'text-danger' })}
                              </div>
                            </div>
                            <div className="form-group col-md-4 input-group-cus">
                              <div>
                                <label
                                  className={edited && ((edited_data.from_time != this.state.from_time) || edited_data.from_time_cate != this.state.from_time_cate)
                                    && 'edited-field'}>From Timing</label>
                                <div className="custom-select-drop dropdown">
                                  <select
                                    className="form-control selectpicker"
                                    onChange={this.handleSelect}
                                    value={this.state.from_time}
                                    name="from_time"
                                    title='Select'
                                  >
                                    {this.state.timingList.length > 0 &&
                                      this.state.timingList.map((item, i) => {
                                        return (
                                          <option value={item.id} >
                                            {item.timing}
                                          </option>
                                        )
                                      })}
                                  </select>
                                  {this.validator.message('Timing', this.state.from_time, 'required', { className: 'text-danger' })}
                                </div>
                              </div>

                              <div>
                                <label>&nbsp;</label>
                                <div className="custom-select-drop dropdown">
                                  <select
                                    className="form-control selectpicker"
                                    onChange={this.handleSelect}
                                    value={this.state.from_time_cate}
                                    name="from_time_cate"
                                  >
                                    <option value="AM">AM</option>
                                    <option value="PM">PM</option>
                                  </select>
                                </div>
                              </div>
                            </div>

                            <div className="form-group col-md-4 input-group-cus">
                              <div>
                                <label
                                  className={edited && ((edited_data.to_time != this.state.to_time) || edited_data.to_time_cate != this.state.to_time_cate)
                                    && 'edited-field'}>To Timing</label>
                                <div className="custom-select-drop dropdown">
                                  <select
                                    className="form-control selectpicker"
                                    onChange={this.handleSelect}
                                    value={this.state.to_time}
                                    name="to_time"
                                    title='Select'
                                  >
                                    {this.state.timingList.length > 0 &&
                                      this.state.timingList.map((item, i) => {
                                        return (
                                          <option value={item.id} >
                                            {item.timing}
                                          </option>
                                        )
                                      })}
                                  </select>
                                  {this.validator.message('Timing', this.state.to_time, 'required', { className: 'text-danger' })}
                                </div>
                              </div>

                              <div>
                                <label>&nbsp;</label>
                                <div className="custom-select-drop dropdown">
                                  <select
                                    className="form-control selectpicker"
                                    onChange={this.handleSelect}
                                    value={this.state.to_time_cate}
                                    name="to_time_cate"
                                    required
                                  >
                                    <option value="AM">AM</option>
                                    <option value="PM">PM</option>
                                  </select>
                                </div>
                              </div>
                            </div>

                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.no_teacher != this.state.no_of_support_staff) && 'edited-field'}>
                                Number of Trainees
                                <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="no_of_support_staff"
                                value={this.state.no_of_support_staff}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                            </div>

                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.est_year != this.state.establishment_year) && 'edited-field'}>
                                Establishment Year
                                <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="establishment_year"
                                value={this.state.establishment_year}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.entry_fee != this.state.entry_fee) && 'edited-field'}>
                                Minimal Entry Fee
                                <span className="astrick">*</span>
                              </label>
                              <input
                                type="number"
                                name="entry_fee"
                                value={this.state.entry_fee}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Minimal Entry Fees', this.state.entry_fee, 'required', { className: 'text-danger' })}
                            </div>

                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.keywords != this.state.keywords) && 'edited-field'}>
                                Keywords</label>
                              <Multiselect
                                isObject={false}
                                options={this.state.keywordsArr} // Options to display in the dropdown
                                selectedValues={this.state.keywords} // Preselected value to persist in dropdown
                                onSelect={this.onSelect} // Function will trigger on select event
                                onRemove={this.onRemove} // Function will trigger on remove event
                              />
                              {/* <textarea
                                name="keywords"
                                value={this.state.keywords}
                                onChange={this.handleChange}
                                className="form-control"
                                placeholder="ex: school,category names,location name,etc"
                              ></textarea> */}
                              {/* {this.validator.message('Website Search Keywords', this.state.keywords, 'required', { className: 'text-danger' })} */}
                            </div>
                          </div>
                        </div>

                        <div className="box-shadow-custom">
                          <div className="row">
                            <div className="col-md-12 col-xs-12">
                              <span className="form-legend">Images</span>
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.images != this.state.images) && 'edited-field'}>
                                Banner Images <span className="astrick">*</span>
                              </label>
                              <input
                                type="file"
                                name="images"
                                onChange={this.handleFile}
                                className="form-control"
                              />
                            </div>
                            {(this.state.edit_image != '' || this.state.tempBanner != '') &&
                              (
                                <div class="col-md-2 col-sm-12 mar-btm" id="edit_image">

                                  <img src={this.state.tempBanner ? this.state.tempBanner : this.state.edit_image} alt="Img" class="img-thumbnail" />

                                </div>
                              )
                            }
                            <div class="col-md-12 float-left mt-4 p-0">
                              <label
                                className={edited && (edited_data.photos != this.state.photos) && 'edited-field'}>
                                Gallery Images <span className="astrick">*</span>
                              </label>
                            </div>

                            <div class="col-md-12 float-left mt-4 p-0">

                              <div class="col-md-12 margin-bottom-mobile-account float-left image-upload">
                                {/* <span class="col-md-12 account-details-text float-left p-0">Image</span> */}
                                <div className='upload-wizard'>
                                  <div className='upload-thumb'>
                                    <ul className='list-inline'>
                                      {this.state.attachment_file.map((file_data, index) => {

                                        var file_url;
                                        if (file_data.name) {
                                          let url = file_data.image_thumb ? file_data.image_thumb : '';
                                          if (url != '') {
                                            file_url = file_data.image_thumb;
                                          } else {
                                            file_url = URL.createObjectURL(file_data);
                                          }

                                          // var file_url = URL.createObjectURL(file_data)
                                          // var file_name = file_data.name
                                          if (file_data.type === 'application/pdf') {
                                            var blob = file_url
                                            //console.log('blob_url', file_data.name)
                                            return (
                                              <li className='previewImg'>
                                                <div className='thumb-img'>

                                                  <img
                                                    src={file_url}
                                                    alt='image'
                                                    title={file_data.name}
                                                  />

                                                </div>
                                                {/* <span className='file-name'>{file_name}</span> */}
                                                <a href='javascript:;' className='del-btn' onClick={() => {
                                                  this.removeImage(file_data.name)
                                                }}>
                                                  <img
                                                    src={'../assets/images/close-icon-white.svg'}
                                                    alt='delete'
                                                  />
                                                </a>
                                              </li>
                                            )
                                          } else {
                                            return (
                                              <li className='previewImg'>
                                                <div className='thumb-img'>
                                                  <img
                                                    src={file_url}
                                                    alt='image'
                                                    title={file_data.name}
                                                  />
                                                </div>
                                                {/* <span className='file-name'>{file_data.name}</span> */}
                                                <a
                                                  href='javascript:;'
                                                  className='del-btn'
                                                  onClick={() => {
                                                    this.removeImage(file_data.name)
                                                  }}
                                                >
                                                  <img
                                                    src={'../assets/images/close-icon-white.svg'}
                                                    alt='delete'
                                                  />
                                                </a>
                                              </li>
                                            )
                                          }
                                        }

                                      })}
                                      <li className='addMore'>
                                        <input
                                          type='file'
                                          name='imgInp[]'
                                          id='imgInp2'
                                          className='add_img'
                                          multiple
                                          onChange={this.loadFile.bind(this)}
                                          accept="image/x-png,image/gif,image/jpeg"
                                        />
                                        <a href='javascript:;' className='add-more'>
                                          <div>
                                            <img src={'../assets/images/upload-icon.svg'} alt='icon' />
                                            Add more
                                          </div>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>

                                </div>

                              </div>

                              {this.validator.message('gallery images', this.state.attachment_file, '', { className: 'text-danger error-msg' })}
                              {/* {this.validator.message('gallery images', this.state.attachment_file, 'required', { className: 'text-danger error-msg' })} */}

                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 col-xs-12 btn-bdr">
                          <button id="btnSubmit" className="btn btn-blue">Preview</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>  


                </div>
              </div>
            </div>

             {this.preview()}

            </AdminLayout>
               
      </React.Fragment >
    );
  }
  
  preview = () => {
    let from_time = this.state.timingList.map((item) => {
      if (item.id == this.state.from_time) return item.timing
    })
    from_time = from_time.filter(n => n).toString();
    let to_time = this.state.timingList.map((item) => {
      if (item.id == this.state.to_time) return item.timing
    })
    to_time = to_time.filter(n => n).toString();
    return (
      <Modal isOpen={this.state.preview} size='lg' className='preview-pop'>
        <ModalBody className='p-0'>
          <Row>
            <Col md='12'>
              <img src='/assets/images/user-header.png' className='preview-header' />
            </Col>
          </Row>
          <Row className='pv-banner'>
            <Col className='pv-banner-bg' md='12'>
              <div className='title-section'>
                <p className="banner-title">{this.state.playarea_name}</p>
                <p className="banner-address">{this.state.address}</p>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <div className='title-section'>
                <h4>About</h4>
                <p className="">{this.state.about_playarea}</p>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <div className='title-section'>
                <h4>Key Information</h4>
                <div className='row'>
                  <div className='col-md-4'>
                    <div className='type-n7ngd'><b>Timing</b></div>
                    <div className='key-po'>
                      <p>
                        {from_time == 'NA' || to_time == 'NA' ? 'NA' :
                          `${from_time} ${this.state.from_time_cate} - ${to_time} ${this.state.to_time_cate}`}
                      </p>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className='type-n7ngd'><b>Number of Trainees</b></div>
                    <div className='key-po'>
                      <p>{this.state.no_of_support_staff}</p>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className='type-n7ngd'><b>Minimal Entry Fee</b></div>
                    <div className='key-po'>
                      <p>{this.state.entry_fee}</p>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className='type-n7ngd'><b>Establishment Year</b></div>
                    <div className='key-po'>
                      <p>{this.state.establishment_year}</p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <div className='title-section'>
                <h4>Amenities</h4>
                <div className='row'>
                  {this.state.facilities.map((item) => {
                    let fac_data = this.state.facilitiesList.filter((data) => data.id == item);
                    if (fac_data.length > 0) {
                      return (
                        <div className='col-md-4'>
                          <div className=''>
                            {fac_data[0].facility}
                          </div>
                        </div>
                      )
                    }
                  })}

                </div>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <div className='title-section'>
                <h4>Gallery</h4>
                <div className='row'>
                  {this.state.attachment_file.map((item) => {
                    if (item.image_thumb) {
                      return (
                        <div className='col-md-4'>
                          <img src={item.image_thumb} className='preview-image' />
                        </div>
                      )
                    } else if (item.name) {
                      let file_url = URL.createObjectURL(item);
                      return (
                        <div className='col-md-4'>
                          <img src={file_url} className='preview-image' />
                        </div>
                      )
                    }
                  })}
                  {this.state.attachment_file.length === 0 && (
                    <div className='col-md-4'>No Gallery Images Found</div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <div className='title-section'>
                <h4>Fees Structure</h4>
                <div className='row'>
                  <div className='col-md-12'>
                    Minimal Entry Fee : {this.state.entry_fee > 0 ? this.state.entry_fee : 'NA'}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <div className='title-section'>
                <h4>Contact Information</h4>
                <div className='row'>
                  <div className='col-md-4'>
                    Email Id : {this.state.email_id}
                  </div>
                  <div className='col-md-4'>
                    Contact : {this.state.phone_number}
                  </div>
                  <div className='col-md-4'>
                    Website : {this.state.website}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <button className='btn btn-sm btn-primary custome-submit' onClick={this.handleSubmit}>
                {this.state.edited && this.state.role == 1 ? 'Approve' : 'Submit'}
              </button>
              {this.state.edited && this.state.role == 1 && (
                <button className='btn btn-sm btn-danger custome-submit' style={{ marginLeft: '10px' }}
                  onClick={this.handleReject}>
                  Reject
                </button>
              )}
              <button className='btn btn-sm btn-defult custome-submit' style={{ marginLeft: '10px' }}
                onClick={() => { this.setState({ preview: false }) }}>Close</button>
            </Col>
          </Row>
        </ModalBody>
      </Modal >
    )
  }
  handleReject = (e) => {
    e.preventDefault();
    let req = JSON.stringify({
      id: this.id
    })
    let toastr = '';
    playareaReject(req).then((res => {
      if (res.status === 1) {
        alert("success"); 
        window.location.href = document.referrer;
      }
    }))
  }
  handleSubmit = (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      let insData = {
        id: this.id ? this.id : '',
        login_id: this.state.vendor_id,
        registration_no: this.state.registration_no,
        area: this.state.area,
        organisation_name: this.state.playarea_name,
        sub_categories: this.state.age_group,
        email_id: this.state.email_id,
        phone_number: this.state.phone_number,
        land_line: this.state.phone_number,
        website: this.state.website,
        about: this.state.about_playarea,
        state: this.state.state,
        location: this.state.location,
        country: this.state.country,
        pincode: this.state.pin_code,
        address: this.state.address,
        google_location: this.state.google_location,
        no_teacher: this.state.no_of_support_staff,
        est_year: this.state.establishment_year,
        facilites: this.state.facilities,
        opening_time: this.state.timing,
        // mode_of_payment: this.state.modeofpayment,
        owner_name: this.state.ownerName,
        entry_fee: this.state.entry_fee,
        images: this.state.images,
        photos: this.state.attachment_file,
        latitude: this.state.latitude,
        longitude: this.state.longitude,
        other_rating: this.state.other_rating,
        from_time: this.state.from_time,
        to_time: this.state.to_time,
        to_time_cate: this.state.to_time_cate,
        from_time_cate: this.state.from_time_cate,
        delete_array: this.state.delete_array,
        keywords: this.state.keywords ? this.state.keywords.join(';') : '',
        sub_type: this.state.sub_type,
        role: this.state.role
      }
      // jQuery("#btnSubmit").attr('disabled', true);
      addPlayArea(insData).then((res) => {
        let toastr = '';
        if (res.status === 1) {
          
          alert("created success!.."); 
          window.location.href = document.referrer;
        } else {
          jQuery("#btnSubmit").attr('disabled', false);
          alert("Something went wrong. try again!..."); 
        }
      });
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };
}
export default verticalKidsPlayAreaEdit;


// WEBPACK FOOTER //
// ./src/components/bewise/verticalKidsPlayAreaEdit.jsx